import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { setDataAuthority } from '@/api/authority';
export default {
  name: 'Datas',
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    authority: {
      default: function _default() {
        return {};
      },
      type: Array
    }
  },
  data: function data() {
    return {
      authoritys: [],
      dataAuthorityId: [],
      needConfirm: false
    };
  },
  created: function created() {
    var _this = this;

    this.authoritys = [];
    this.dataAuthorityId = [];
    this.roundAuthority(this.authority);
    this.row.dataAuthorityId && this.row.dataAuthorityId.map(function (item) {
      var obj = _this.authoritys && _this.authoritys.filter(function (au) {
        return au.authorityId === item.authorityId;
      }) && _this.authoritys.filter(function (au) {
        return au.authorityId === item.authorityId;
      })[0];

      _this.dataAuthorityId.push(obj);
    });
  },
  methods: {
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.authDataEnter();
    },
    all: function all() {
      this.dataAuthorityId = _toConsumableArray(this.authoritys);
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    self: function self() {
      var _this2 = this;

      this.dataAuthorityId = this.authoritys.filter(function (item) {
        return item.authorityId === _this2.row.authorityId;
      });
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    selfAndChildren: function selfAndChildren() {
      var arrBox = [];
      this.getChildrenId(this.row, arrBox);
      this.dataAuthorityId = this.authoritys.filter(function (item) {
        return arrBox.indexOf(item.authorityId) > -1;
      });
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    getChildrenId: function getChildrenId(row, arrBox) {
      var _this3 = this;

      arrBox.push(row.authorityId);
      row.children && row.children.map(function (item) {
        _this3.getChildrenId(item, arrBox);
      });
    },
    // 提交
    authDataEnter: function authDataEnter() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return setDataAuthority(_this4.row);

              case 2:
                res = _context.sent;

                if (res.code === 0) {
                  _this4.$message({
                    type: 'success',
                    message: '资源设置成功'
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //   平铺角色
    roundAuthority: function roundAuthority(authoritys) {
      var _this5 = this;

      authoritys && authoritys.map(function (item) {
        var obj = {};
        obj.authorityId = item.authorityId;
        obj.authorityName = item.authorityName;

        _this5.authoritys.push(obj);

        if (item.children && item.children.length) {
          _this5.roundAuthority(item.children);
        }
      });
    },
    //   选择
    selectAuthority: function selectAuthority() {
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    }
  }
};